import { render, staticRenderFns } from "./kra-index.vue?vue&type=template&id=47d2de2c&"
import script from "./kra-index.vue?vue&type=script&lang=js&"
export * from "./kra-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports